import { forwardRef } from 'react';
import NumberFormat, { NumberFormatProps } from 'react-number-format';
import { TextField, TextFieldProps } from '../textField';

type NumberInputProps = {
  onChange: (event: { target: { name: unknown; value: unknown } }) => void;
  [key: string]: unknown;
};

const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>(
  function NumberInput(props, ref) {
    const { onChange, ...other } = props;

    return (
      <NumberFormat
        {...other}
        onValueChange={(values) =>
          onChange?.({
            target: { name: props.name, value: values.floatValue }
          })
        }
        getInputRef={ref}
      />
    );
  }
);

export default NumberInput;

type Props = {
  numberInputProps: NumberFormatProps;
} & TextFieldProps;

/**
 * NumberField adds number specific behavior to the TextField component.
 *
 * Pass the number specific props using numberInputProps. See react-number-format
 * documentation for the available options.
 *
 * react-number-format: https://www.npmjs.com/package/react-number-format
 */
export const NumberField = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const { numberInputProps, ...textFieldProps } = props;

  return (
    <TextField
      {...textFieldProps}
      inputComponent={NumberInput}
      inputProps={{ ...numberInputProps, ref }}
    />
  );
});
